/**
 * V17.516 (Phase 0, brief 2026-10-25-003 step 8): a real 404 for any unknown URL
 * (App.tsx `path="*"`). Lao by default, English on toggle.
 */
import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LanguageContext } from '../contexts/LanguageContext';

const TEXT = {
  lo: { title: 'ບໍ່ພົບໜ້ານີ້', body: 'ບໍ່ມີໜ້າທີ່ທ່ານກຳລັງຊອກຫາ. ກວດທີ່ຢູ່ ຫຼື ກັບໄປໜ້າຫຼັກ.', back: 'ກັບໄປໜ້າຫຼັກຂອງທ່ານ' },
  en: { title: 'Page not found', body: 'The page you are looking for does not exist. Check the address or go back home.', back: 'Back to your home page' },
};

export default function NotFound() {
  const language = useContext(LanguageContext)?.language ?? 'lo';
  const t = TEXT[language];
  const { isAuthenticated, getDefaultRoute } = useAuth();
  const location = useLocation();
  return (
    <div data-testid="not-found-page" lang={language} className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="max-w-lg text-center">
        <p className="text-sm font-semibold text-gray-500 dark:text-gray-400">404</p>
        <h1 className="mt-1 text-2xl font-bold text-gray-900 dark:text-gray-100">{t.title}</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400">{t.body}</p>
        <p className="mt-2"><code className="font-mono text-sm text-gray-700 dark:text-gray-300">{location.pathname}</code></p>
        <div className="mt-6">
          <Link
            to={isAuthenticated ? getDefaultRoute() : '/login'}
            className="inline-block rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            {t.back}
          </Link>
        </div>
      </div>
    </div>
  );
}
